import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  inject,
  viewChild,
} from '@angular/core';
import { CustomColumnDefinition } from '../../../types/colum-definition.type';
import { CellAdapter } from '../cell.adapter';
import { OptionDirective } from '@client';

@Component({
  selector: 'app-custom-cell',
  template: ` <ng-template option /> `,
  standalone: true,
  imports: [OptionDirective],
})
export class CustomCell extends CellAdapter implements AfterViewInit {
  changeRef = inject(ChangeDetectorRef);
  customCell = viewChild(OptionDirective);

  ngAfterViewInit(): void {
    const column = this.column() as CustomColumnDefinition;

    if (this.customCell() && column.type === 'custom' && column.component) {
      const viewContainerRef = this.customCell()?.viewContainerRef;
      viewContainerRef?.clear();

      const componentRef = viewContainerRef?.createComponent<CellAdapter>(
        column.component,
      );

      componentRef?.setInput('row', this.row());
      componentRef?.setInput('column', this.column());

      this.changeRef.detectChanges();
    }
  }
}
